export default __webpack_public_path__ + "static/media/1.01655d11.jpg";